import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import ResultItem from '../ResultItem/index.jsx';
import './style.scss';

export const InfoWindow = ({ member, ref }) => {
    return createPortal(
        <div className="cbdce-education-finder__map-info-window" ref={ref}>
            {member && (
                <ResultItem member={member} embeddedInPopover={true}/>
            )}
        </div>,
        document.body
    );
};

export const Map = ({
    mapRef,
    googleApis,
    members
}) => {
    const [markers, setMarkers] = useState([]);

    const [selectedMember, setSelectedMarker] = useState(null);
    const portalRef = useRef(null);
    const infoWindow = useRef(null);

    useEffect(() => {
        if (!googleApis.map) return;
        if (!infoWindow.current && portalRef.current) {
            infoWindow.current = new window.google.maps.InfoWindow({
                content: portalRef.current
            })
        }

        for (const prevMarker of markers) {
            prevMarker.setMap(null);
        }

        const bounds = new window.google.maps.LatLngBounds();

        const nextMarkers = (googleApis.map
            ? members.map((member) => {
                const {
                    firstName,
                    lastName,
                    geoLocation: {lat, lng},
                } = member;

                const marker = new window.google.maps.Marker({
                    position: {lat, lng},
                    map: googleApis.map,
                    title: `${firstName} ${lastName}`,
                });
                bounds.extend(new window.google.maps.LatLng(lat, lng));


                marker.addListener('click', () => {
                    setSelectedMarker(member);
                    if (infoWindow.current) {
                        console.log('Opening info window for member', member);
                        infoWindow.current.open(googleApis.map, marker);
                    } else {
                        console.warn('InfoWindow not initialized yet');
                    }
                });

                return marker;
            })
            : []
        );
        if (nextMarkers.length) {
            window.google.maps.event.addListenerOnce(googleApis.map, 'bounds_changed', function(event) {
                if (this.getZoom() > 17){
                    this.setZoom(17);
                }
            });
            googleApis.map.fitBounds(bounds);
        } else {
            googleApis.map.setZoom(4);
            googleApis.map.setCenter(new window.google.maps.LatLng(37.0902, -95.7129));

        }
        setMarkers(nextMarkers);

    }, [ googleApis.map, portalRef.current, members ]);



    return (
        <>
            <div ref={mapRef} className="cbdce-education-finder__map"></div>
            <InfoWindow member={selectedMember} ref={portalRef} />
        </>
    );
};

export default Map;
